export default {
      id: "tile-check-deposit-usage",
      viewBox: "0 2 45 37",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#tile-check-deposit",
      toString: function () {
        return this.url;
      }
    }